import React from "react";
import "./summaryBox.scss";
import { CalculateStore } from "../../../stores/calculateStore";
import { inject, observer } from "mobx-react";
import Formatter from "../../../helpers/formatter";
import classNames from "classnames";

interface InstallmentsProps {
  calculateStore?: CalculateStore;

}

@inject("calculateStore")
@observer
export default class Installments extends React.Component<InstallmentsProps, any> {
  render() {
    const firstInstallment = this.props.calculateStore!.calculationResponse!.installments[0].amount;
    const anotherInstallment = this.props.calculateStore!.calculationResponse!.installments[1].amount;
    if (this.isFirstInstallmentSameAsAnother(firstInstallment, anotherInstallment)) {
      return (
        <>
          {this.renderInstallment("Wysokość rat", firstInstallment)}
        </>
      );
    } else {
      return (
        <>
          {this.renderInstallment("Wysokość pierwszej raty: ", firstInstallment)}
          {this.renderInstallment("i kolejnych rat: ", anotherInstallment, "another-installments")}
        </>

      );
    }
  }

  private renderInstallment(label: string, installment: string | number, className?: string) {
    const value = installment ?
      `${Formatter.decimalPriceFormat(Formatter.convertCentsToNormalNumber(installment))} zł` :
      "???";
    return (
      <div className={classNames(`installment ${this.props.calculateStore!.requireRecalculate ? "require-recalculate" : ""}`, className)}>
        <span className="label">{label}</span>
        <span className="value">{value}</span>
      </div>);
  }

  private isFirstInstallmentSameAsAnother(firstInstallment: number, anotherInstallment: number) {
    return firstInstallment === anotherInstallment;
  }
}
